/**
 * panellock: `]` opens or shuts both side panels (founder, 19 Oct 2026; was
 * `ss` until 28 Oct 2026, moved to one key). It is a single-key shortcut
 * (useKeyboardShortcuts), listed under `?`.
 *
 * Either panel open: `]` shuts both. Both shut: `]` opens both, which also
 * ends a lock, as any opening by hand does.
 *
 * It presses each panel's own open/shut control, marked `data-panel-toggle`
 * with `data-open`, so the panels need no code of their own for it. A control
 * not on screen (the desktop column on a phone, `display:none`) is left alone.
 */

/** Press both panels' controls the way `]` goes. Returns whether they now open. */
export function togglePanels(root: ParentNode = document): boolean {
    const toggles = [...root.querySelectorAll<HTMLElement>('[data-panel-toggle]')]
        .filter(el => el.getClientRects().length > 0);
    const open = !toggles.some(el => el.dataset.open === 'true');
    for (const el of toggles) if (el.dataset.open !== String(open)) el.click();
    return open;
}
